export default __webpack_public_path__ + "static/media/logo.1cdd5261.svg";